module.exports = __webpack_public_path__ + "img/settings.3d991703.svg";